export function ticketmasterListingDisplay(ticketmaster) {
  return {
    label: String(ticketmaster?.status || '').trim().toUpperCase() === 'SUCCESS'
      ? 'Synced'
      : 'Not synced',
    verified: ticketmaster?.discovery?.state === 'listed',
  };
}

export function ticketmasterListingNeedsAttention(ticketmaster) {
  const display = ticketmasterListingDisplay(ticketmaster);
  return display.label !== 'Synced' || !display.verified;
}
